(function ($, Drupal) {
  Drupal.behaviors.aitBurger = {
    attach: function () {
      $('.mobile-menu-burger').once().on('click', function () {
        $(this).toggleClass('collapsed');
        $('.region--header-mobile').toggleClass('active');
        $('body').toggleClass('inactive-body');
      });
    }
  };

  Drupal.behaviors.aitLanguages = {
    attach: function () {
      $('.language-button').once().on('click', function () {
        $(this).toggleClass('collapsed');
        $('.region--header-mobile-languages').toggleClass('active');
        $('body').toggleClass('inactive-body');
      });
    }
  };

  Drupal.behaviors.aitLanguagesDesktop = {
    attach: function () {
      $('.language-button-desktop').once().on('click', function () {
        $(this).toggleClass('collapsed');
      });
    }
  };

  Drupal.behaviors.aitSearch = {
    attach: function () {
      $('.search-button').once().on('click', function () {
        $(this).toggleClass('collapsed');
        $('.region--header-mobile-search').toggleClass('active');
        $('body').toggleClass('inactive-body');
      });
    }
  };

  Drupal.behaviors.aitStickyHeader = {
    attach: function () {
      var $sticky = $('.section--header');
      var $html = $('html');
      var $window = $(window);

      if ($sticky.offset()) {
        var stickyTop = $sticky.offset().top;
        var stickOffset = 0;

        $window.once().on('scroll', function () {
          var windowTop = $window.scrollTop();
          var toolbarHeight = parseInt($('body').css('padding-top'));
          var login = document.location.href.indexOf('login') === -1;
          var register = document.location.href.indexOf('register') === -1;

          if ($window.outerWidth() < 992) {
            stickOffset = toolbarHeight;
          }
          if ((stickyTop < windowTop + toolbarHeight - stickOffset) && login && register) {
            $html.css({paddingTop: $sticky.outerHeight()});
            $sticky.css({position: 'fixed', top: (toolbarHeight - stickOffset), 'z-index': 9998, width: '100%' });
            $sticky.addClass('sticky-header');
          }
          if (windowTop === 0) {
            if (document.getElementById('toolbar-administration')) {
              $sticky.css({position: 'relative', top: 0,  'z-index': 3, width: '100%'});
            }
            else {
              $sticky.css({position: 'relative', top: (toolbarHeight), 'z-index': 1, width: '100%'});
            }
            $sticky.removeClass('sticky-header');
            $html.css({paddingTop: '0' });
          }
        });
      }
    }
  };
})(jQuery, Drupal);
